<!--
  ~ Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (permission()) {
<div class="container import-file-data-zip">
  <h2>Import Files (Zip)</h2>

  <div class="message">
    Upload a zip file of up to 1 GB and 50,000 files; each file inside it may be up to 100 MB. Each file is added to file data with its path in the zip as the
    source URL, a reference count of 0, and its extension as the file type. A file whose path already exists is
    skipped and listed as failed, so the same zip can be imported again safely.
  </div>

  <app-file-upload-card [header]="'Zip file:'" [subheader]="'*Select one zip file'"
                        [accept]="'.zip,application/zip,application/x-zip-compressed'"
                        (filesSelected)="onZipSelected($event)"></app-file-upload-card>

  <div class="actions">
    <p-button label="Import" (click)="startImport()" (keydown.enter)="startImport()"
              [disabled]="!selectedFile() || running()"
              [loading]="running()" class="gm-btn-primary"></p-button>
  </div>

  @if (errorMessage()) {
    <div class="message error">{{ errorMessage() }}</div>
  }

  @if (uploading()) {
    <div class="progress-section">
      <div class="status-line">Uploading {{ selectedFile()?.name }}: {{ uploadPercent() }}%</div>
      <p-progressBar [value]="uploadPercent()"></p-progressBar>
    </div>
  }

  @if (jobStatus(); as status) {
    <div class="progress-section">
      <div class="status-line" [class.error]="status.status === 'FAILED'">{{ status.message }}</div>
      @if (status.totalFiles !== null) {
        <div class="status-line">{{ processedCount() }} of {{ status.totalFiles }} files processed</div>
        <p-progressBar [value]="progressPercent()"></p-progressBar>
      }
      <div class="counts">
        <span class="count success">Imported: {{ status.succeededCount }}</span>
        <span class="count failed">Failed: {{ status.failedCount }}</span>
      </div>
    </div>

    @if (status.failed?.length) {
      <h3>Failed files ({{ status.failed.length }})</h3>
      <p-table [value]="status.failed" [paginator]="status.failed.length > 25" [rows]="25" size="small">
        <ng-template pTemplate="header">
          <tr><th scope="col">Path in zip</th><th scope="col">Reason</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr><td>{{ row.path }}</td><td>{{ row.reason }}</td></tr>
        </ng-template>
      </p-table>
    }

    @if (status.succeeded?.length) {
      <h3>Imported files ({{ status.succeeded.length }})</h3>
      <p-table [value]="status.succeeded" [paginator]="status.succeeded.length > 25" [rows]="25" size="small">
        <ng-template pTemplate="header">
          <tr><th scope="col">Source URL</th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-path>
          <tr><td>{{ path }}</td></tr>
        </ng-template>
      </p-table>
    }
  }
</div>
}
